module.exports = {"launched":"Erfolgreich gestartet","message":"Testen Sie, wie Nutzerdaten aussehen, wenn Sie sie zurückerhalten","trigger_callback":"Auslöser-Callback"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/i18next/de/devmode.json
// module id = 482
// module chunks = 248 1696